/* eslint-disable no-unused-vars */
import { Col, Container, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

import { useNavigate } from "react-router-dom";
import UserAddBot from "../Modal/AddBot";

const UserCreateBot = () => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();
  const [addModalShow, setAddModalShow] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const { t } = useTranslation();
  const [isNoBot, setIsNoBot] = useState(0);
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [getBots, setGetBots] = useState(true);
  const [botList, setBotList] = useState([]);

  function createBot(data) {
    if (data && id) {
      // CheckingMSgLimit();
      setLoading(true);
      axios
        .put(
          `${API_URL}/${API_VERSION}/bot`,
          {
            name: data,
            user: id,
            settings: {
              // prompt:
              //   "You are a helpful AI assistant. Use the following pieces of context to answer the question at the end. If you don't know the answer, just say you don't know. DO NOT try to make up an answer. If the question is not related to the context, politely respond that you are tuned to only answer questions that are related to the context.",
              model: "gpt-3.5-turbo",
              temperature: 0,
              // messageCount: 20,
              messageLimit: 100,
              visibility: "public",
            },
            chatInterface: {
              logoName: "https://seekicon.com/free-icon-download/chat_7.svg",
            },
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          setAddModalShow(false);
          navigate(`/admin/my-bots/${id}/${response.data.botId}`);
          setType("Success");
          setMessage("Your bot is created.");
          setShowAlert(true);
          setGetBots(true);
        })
        .catch((error) => {
          setLoading(false);
          setType("Danger");
          setMessage("Something went to wrong.");
          setShowAlert(true);
        });
    }
  }

  useEffect(() => {
    const getAllBots = () => {
      setLoading(true);
      axios
        .get(`${API_URL}/${API_VERSION}/bot/user/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setLoading(false);
          setBotList(response.data);
          setIsNoBot(1);
          //setGetBots(false);
        })
        .catch((error) => {
          setLoading(false);
          setType("Danger");
          setMessage("Something went to wrong.");
          setShowAlert(true);
        });
    };
    getAllBots();
  }, [id, API_URL, API_VERSION]);
  return (
    <>
      <section className="userbots_main">
        <section className="create_bot_main">
          <Container className="mb-5">
            {/* <Link className="button" to="/admin/clients">
              <i className="fa fa-arrow-left"></i> {t("Back")}
            </Link> */}
            <Row className="justify-content-center">
              {!!isNoBot && botList.length === 0 && (
                <Col lg={10}>
                  <div className="create_bot d-flex flex-column">
                    <strong className="createText">
                      {t("Its look like you do not have any active")}{" "}
                      <span>{t("chatbot")}</span>.
                    </strong>
                    <small>{t("Start creating your first bot.")}</small>
                    <Link
                      className="userbutton mt-2 py-4 px-5"
                      onClick={() => setAddModalShow(true)}
                    >
                      {" "}
                      {t("Create A Bot")}
                    </Link>
                  </div>
                </Col>
              )}
            </Row>
          </Container>
        </section>
      </section>
      <UserAddBot
        show={addModalShow}
        onHide={() => setAddModalShow(false)}
        createBot={createBot}
      />
    </>
  );
};
export default UserCreateBot;
